import Grid from '@mui/material/Grid';
import PreventionSection from 'modules/my-sales/submodules/orders/detailOrderPurchase/components/PreventionSection';
import FraudDialog from 'modules/my-sales/submodules/orders/list/components/FraudDialog';
import FraudPrevention from 'modules/my-sales/submodules/orders/list/components/FraudPrevention';

const FraudSection = ({
  type,
  orderDetails,
  idTransaction,
  controllerProps,
  fraudStyle,
  chargebackStyle,
  handleOpenPopUp,
}) => {
  const hasPrevention =
    type !== 'detailsSimIpb' &&
    type !== 'DetailsFailedTransactions' &&
    type !== 'DetailsVinculationOrders';
  const popupHandler = controllerProps?.handleOpenPopUp || handleOpenPopUp;

  return (
    <>
      {hasPrevention && type !== 'detailPurchase' && type !== 'AiraloDetails' && (
        <PreventionSection
          type={type}
          title={'Prevención'}
          orderDetails={orderDetails}
          fallbackId={idTransaction}
          handleOpenPopUp={popupHandler}
          fraudStyle={fraudStyle}
          chargebackStyle={chargebackStyle}
        />
      )}
      {type === 'detailPurchase' && (
        <Grid item size={{ xs: 12 }} mt={3}>
          <FraudPrevention
            order_details={orderDetails}
            handleOpenPopUp={popupHandler}
            fraudStyle={fraudStyle}
            chargebackStyle={chargebackStyle}
          />
        </Grid>
      )}
      {hasPrevention && (
        <FraudDialog
          openActionFraud={controllerProps.openActionFraud}
          handleClose={controllerProps.handleClose}
          fraudChargebackPopupTitle={controllerProps.fraudChargebackPopupTitle}
          setDescriptionTransaction={controllerProps.setDescriptionTransaction}
          setError={controllerProps.setError}
          error={controllerProps.error}
          loadingFraudAndChargeback={controllerProps.loadingFraudAndChargeback}
          dialogMessage={controllerProps.dialogMessage}
          isError={controllerProps.isError}
          handleConfirm={controllerProps.handleConfirm}
          detailTransactionChargeback={controllerProps.detailTransactionChargeback}
          detailTransactionFraud={controllerProps.detailTransactionFraud}
        />
      )}
    </>
  );
};
export default FraudSection;
